import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";

const Search = styled("div")(({ theme }) => ({
  color: theme.palette.input_field.text,
  position: "relative",
  borderRadius: "8px",
  backgroundColor: theme.palette.input_field.fill,
  "&:hover": {
    backgroundColor: theme.palette.input_field.fill,
  },
  marginLeft: 0,
  width: "100%",
  alignSelf: "flex-end",
  border: `1px solid ${theme.palette.primary.main}`,
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  color: theme.palette.primary.main,
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: theme.palette.input_field.text,
  borderRadius: "8px",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    width: "100%",
  },
}));

export default function ListSearchBar({ onChange, value }) {
  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Search>
        <SearchIconWrapper>
          <SearchIcon />
        </SearchIconWrapper>
        <StyledInputBase
          placeholder="Search…"
          inputProps={{ "aria-label": "search" }}
          onChange={onChange}
          value={value}
        />
      </Search>
    </Box>
  );
}
